<script setup lang="ts">
interface Prors {
  icon?: string
}
withDefaults(defineProps<Prors>(), {
  icon: '',
  // icon: 'https://static.tronscan.org/production/logo/THb4CqiFdwNHsWsQCs4JhzwjMWys4aqCbF.png',
  // icon: 'i-local:trx',
})
</script>

<template>
  <div class="bg-[#202C52] flex justify-center items-center px-3 h-40px lt-tablet:h-34px rounded-md cursor-pointer">
    <img v-if="icon" class="w-20px h-20px mr-[8px]" :src="icon">
    <span class="mr-2 text-14px text-white"><slot>请选择</slot></span>
    <i class="i-ant-design:caret-down-outlined select-down-icon relative top-1px" />
  </div>
</template>
